/* Bottomland PDP behaviour for sections/bl-product.liquid. Plain JS, no dependencies.
   - Panels: each product of a pair (Men / Women, Duffle / Tote) has its own gallery, pickers and variant
     data, rendered server-side; the toggle shows one, carries the shared style / size across, and updates
     the hidden variant id, product-id, price, title and the URL (to that product, keeping ?view= etc.).
   - Gallery: arrows, thumbnails, swipe; jumps to the variant's featured image.
   - Options: hides values with no variant for the choices above them and resolves the variant.
   - Fit chooser: writes the same localStorage keys and values as snippets/product-sizing.liquid
     (patternOnFile / whiteGlove) and follows tailor2Complete for the Virtual Tailor message.
   - Women's pant options (Waist Height / Front Pockets) post only while the women's pant is showing.
   - Monogram: posts Lettering + Color only when the box is ticked. The monogram is paid: ticked, the button
     shows the total, and submit adds the pant plus the $25 add-on product (nested under the pant, so Shopify
     drops it if the pant is removed) in one /cart/add.js call, then goes to /cart.
   Otherwise add to cart stays a normal form POST to /cart/add. */
(function () {
  if (window.BLPDP) return;
  window.BLPDP = { version: 2 };

  function all(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function storageGet(key) { try { return localStorage.getItem(key); } catch (e) { return null; } }
  function storageSet(key, value) { try { localStorage.setItem(key, value); } catch (e) {} }

  /* ---------- Gallery (one per product) ---------- */
  function initGallery(scope) {
    var slides = all(scope, '[data-bl-slide]');
    var thumbs = all(scope, '[data-bl-thumb]');
    var strip = scope.querySelector('[data-bl-thumbs]');
    var index = Math.max(0, slides.findIndex(function (s) { return !s.hidden; }));

    function show(i) {
      if (!slides.length) return;
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.hidden = n !== index; });
      thumbs.forEach(function (t, n) {
        if (n === index) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
      var t = thumbs[index];
      if (strip && t && strip.scrollWidth > strip.clientWidth) {
        var pad = parseFloat(getComputedStyle(strip).paddingLeft) || 0; /* the phone strip has gutter padding */
        var left = t.offsetLeft - pad, right = t.offsetLeft + t.offsetWidth + pad;
        if (left < strip.scrollLeft || right > strip.scrollLeft + strip.clientWidth) {
          strip.scrollTo({ left: left, behavior: 'smooth' });
        }
      }
    }

    var prev = scope.querySelector('[data-bl-prev]');
    var next = scope.querySelector('[data-bl-next]');
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });

    /* Swipe on the main image (touch only; mouse users have the arrows). */
    var stage = scope.querySelector('.bl-pdp__stage');
    var startX = null, startY = null;
    if (stage && slides.length > 1) {
      stage.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX; startY = e.touches[0].clientY;
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX, dy = e.changedTouches[0].clientY - startY;
        startX = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(index + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }

    return {
      showMedia: function (mediaId) {
        var n = slides.findIndex(function (s) { return s.dataset.mediaId === String(mediaId); });
        if (n >= 0) show(n);
      }
    };
  }

  /* ---------- One product's pickers and variant data ---------- */
  function makePanel(root, el, ctx) {
    var id = el.dataset.blPanel;
    var data = { variants: [] };
    var json = el.querySelector('[data-bl-product]');
    if (json) { try { data = JSON.parse(json.textContent); } catch (e) {} }
    var variants = data.variants || [];
    var groups = all(el, '[data-bl-option]');
    var media = root.querySelector('.bl-pdp__media[data-bl-panel="' + id + '"]');

    var panel = {
      id: id,
      url: el.dataset.url,
      title: el.dataset.title,
      womens: el.dataset.womensPant === 'true',
      variant: null,
      gallery: media ? initGallery(media) : { showMedia: function () {} }
    };

    function selected() {
      return groups.map(function (g) {
        var c = g.querySelector('.bl-opt__input:checked');
        return c ? c.value : null;
      });
    }
    function matchesAbove(v, sel, upto) {
      for (var j = 0; j < upto; j++) if (v.options[j] !== sel[j]) return false;
      return true;
    }

    panel.values = selected;

    /* Take over the choices from the other product where it has the same value (Straight, Boot, Skinny;
       XS to 3XL). Anything it does not have keeps this product's own selection. */
    panel.carry = function (values) {
      groups.forEach(function (g, i) {
        if (!values || values[i] == null) return;
        var match = all(g, '.bl-opt__input').filter(function (input) { return input.value === values[i]; })[0];
        if (match) match.checked = true;
      });
    };

    panel.refresh = function (userChange) {
      var sel = selected();
      groups.forEach(function (g, i) {
        var firstAvailable = null, firstExisting = null;
        all(g, '.bl-opt__input').forEach(function (input) {
          var exists = false, available = false;
          variants.forEach(function (v) {
            if (v.options[i] === input.value && matchesAbove(v, sel, i)) {
              exists = true;
              if (v.available) available = true;
            }
          });
          var item = input.closest('[data-bl-value]');
          item.hidden = !exists;
          input.disabled = !exists;
          item.classList.toggle('is-soldout', exists && !available);
          if (exists && !firstExisting) firstExisting = input;
          if (available && !firstAvailable) firstAvailable = input;
        });
        var current = g.querySelector('.bl-opt__input:checked');
        if (!current || current.disabled) {
          var pick = firstAvailable || firstExisting;
          if (pick) { pick.checked = true; sel[i] = pick.value; }
        }
        var label = g.querySelector('[data-bl-selected]');
        if (label) label.textContent = sel[i] || '';
      });

      var variant = null;
      if (!groups.length) {
        variant = variants.filter(function (v) { return v.id === data.selected; })[0] || variants[0] || null;
      }
      for (var k = 0; k < variants.length && !variant; k++) {
        var v = variants[k];
        if (v.options.every(function (o, n) { return o === sel[n]; })) variant = v;
      }
      panel.variant = variant;
      if (ctx.active === panel) ctx.apply(panel, userChange);
    };

    groups.forEach(function (g) {
      g.addEventListener('change', function (e) {
        if (e.target.classList.contains('bl-opt__input')) panel.refresh(true);
      });
    });
    return panel;
  }

  /* ---------- Shared: variant id, price, title, URL, add to cart ---------- */
  function initShared(root, ctx) {
    var idInput = root.querySelector('[data-bl-variant-id]');
    var form = idInput && idInput.form;
    var price = root.querySelector('[data-bl-price]');
    var title = root.querySelector('[data-bl-title]');
    var atc = root.querySelector('[data-bl-atc]');
    var atcLabel = root.querySelector('[data-bl-atc-label]');
    var womens = root.querySelector('[data-bl-womens]');

    function renderPrice(v) {
      if (!price || !v) return;
      price.textContent = '';
      if (v.compare) {
        var s = document.createElement('s');
        s.textContent = v.compare;
        price.appendChild(s);
      }
      var span = document.createElement('span');
      span.textContent = v.price;
      price.appendChild(span);
    }

    ctx.renderAtc = function () {
      if (!atc) return;
      var v = ctx.variant;
      var text = !v ? atc.dataset.labelUnavailable : (v.available ? atc.dataset.labelAdd : atc.dataset.labelSoldout);
      /* With the paid monogram ticked, the button carries the total (pant + add-on). */
      if (v && v.available && v.price_mono && ctx.monoOn && ctx.monoOn()) text += ' · ' + v.price_mono;
      atc.disabled = !v || !v.available || ctx.fitBlocked;
      if (atcLabel && text) atcLabel.textContent = text;
    };

    /* Waist Height / Front Pockets only exist for the women's pant; disabled inputs are not posted. */
    ctx.syncWomens = function () {
      if (!womens) return;
      var on = !!(ctx.active && ctx.active.womens);
      womens.hidden = !on;
      all(womens, 'input').forEach(function (i) { i.disabled = !on; });
    };

    ctx.apply = function (panel, userChange) {
      var v = panel.variant;
      ctx.variant = v;
      if (v) {
        if (idInput) idInput.value = v.id;
        renderPrice(v);
        if (userChange) {
          if (v.media) panel.gallery.showMedia(v.media);
          try {
            var url = new URL(window.location.href);
            if (panel.url) url.pathname = panel.url;
            url.searchParams.set('variant', v.id);
            window.history.replaceState(window.history.state, '', url.toString());
          } catch (e) {}
        }
      }
      if (title && panel.title && title.textContent !== panel.title) title.textContent = panel.title;
      var pid = form && form.querySelector('input[name="product-id"]');
      if (pid) pid.value = panel.id;
      ctx.renderAtc();
    };

    /* Label beside Waist Height / Front Pockets follows the pick. */
    all(root, '[data-bl-prop]').forEach(function (g) {
      g.addEventListener('change', function (e) {
        var label = g.querySelector('[data-bl-selected]');
        if (label && e.target.checked) label.textContent = e.target.value;
      });
    });
  }

  /* ---------- Men / Women (or Duffle / Tote) toggle ---------- */
  function activate(root, ctx, id, userChange) {
    var next = ctx.panels[id];
    if (!next || next === ctx.active) return;
    var carried = ctx.active ? ctx.active.values() : null;
    all(root, '[data-bl-panel]').forEach(function (el) { el.hidden = el.dataset.blPanel !== id; });
    ctx.active = next;
    if (carried) next.carry(carried);
    ctx.syncWomens();
    next.refresh(userChange);
  }

  function initPair(root, ctx) {
    var pair = root.querySelector('[data-bl-pair]');
    if (!pair || !ctx.active) return;
    /* Match the toggle to the product the page opened on (a restored form can disagree). */
    var own = pair.querySelector('.bl-opt__input[value="' + ctx.active.id + '"]');
    if (own) own.checked = true;
    pair.addEventListener('change', function (e) {
      if (e.target.checked) activate(root, ctx, e.target.value, true);
    });

    /* The other product's photos are lazy in a hidden panel, so they would only start loading on the swap.
       Warm its current photo once the page has loaded, and all its photos when the shopper reaches for the toggle. */
    function warm(everything) {
      all(root, '.bl-pdp__media[hidden]').forEach(function (m) {
        all(m, everything ? '[data-bl-slide] img' : '[data-bl-slide]:not([hidden]) img').forEach(function (img) {
          img.loading = 'eager';
        });
      });
    }
    var warmed = false;
    function warmAll() { if (!warmed) { warmed = true; warm(true); } }
    ['pointerenter', 'focusin', 'touchstart'].forEach(function (type) {
      pair.addEventListener(type, warmAll, { passive: true, once: true });
    });
    function idle() { (window.requestIdleCallback || setTimeout)(function () { warm(false); }); }
    if (document.readyState === 'complete') idle();
    else window.addEventListener('load', idle);
  }

  /* ---------- Tailored exclusively for you ---------- */
  function initFit(root, ctx) {
    var fit = root.querySelector('[data-bl-fit]');
    if (!fit) return;
    var inputs = all(fit, '.bl-fit__input');
    var requireFit = fit.dataset.require === 'true';

    function measured() { return storageGet('tailor2Complete') === 'Yes'; }
    function currentOption() {
      var c = fit.querySelector('.bl-fit__input:checked');
      return c ? c.value : 'vt';
    }
    /* Same keys and values as updateLocalStorage() in snippets/product-sizing.liquid. */
    function write(option) {
      if (option === 'vt') {
        storageSet('patternOnFile', '');
        storageSet('whiteGlove', '');
      } else if (option === 'saved') {
        storageSet('patternOnFile', 'Use Pattern on File');
        storageSet('whiteGlove', '');
      } else if (option === 'call') {
        storageSet('patternOnFile', '');
        storageSet('whiteGlove', 'Contact ASAP for measurements.');
      }
    }
    function render() {
      var option = currentOption();
      var state = option === 'vt' ? (measured() ? 'vt-ok' : 'vt-alert') : option;
      root.setAttribute('data-fit', state);
      ctx.fitBlocked = requireFit && state === 'vt-alert';
      ctx.renderAtc();
    }
    function openTailor() {
      var $ = window.jQuery;
      if ($ && $.fn && $.fn.modal && document.getElementById('VirtualTailorModal')) $('#VirtualTailorModal').modal();
    }

    inputs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (!input.checked) return;
        write(input.value);
        render();
      });
    });

    /* A pointer click on the Virtual Tailor card also opens the tailor. Keyboard selection (arrows, space)
       only selects; the links in the message open it from the keyboard. */
    var vtCard = fit.querySelector('[data-fit-card="vt"]');
    if (vtCard) {
      vtCard.addEventListener('click', function (e) {
        if (e.target.matches('input') || e.target.closest('[data-bl-tip]')) return;
        openTailor();
      });
    }
    all(root, '[data-bl-open-tailor]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); openTailor(); });
    });

    /* "?" shows the card's tooltip on tap without picking the card. */
    all(fit, '[data-bl-tip]').forEach(function (tip) {
      tip.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var card = tip.closest('.bl-fit__card');
        var open = card.hasAttribute('data-tip-open');
        all(fit, '[data-tip-open]').forEach(function (c) { c.removeAttribute('data-tip-open'); });
        if (!open) card.setAttribute('data-tip-open', '');
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('[data-bl-tip]')) {
        all(fit, '[data-tip-open]').forEach(function (c) { c.removeAttribute('data-tip-open'); });
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') all(fit, '[data-tip-open]').forEach(function (c) { c.removeAttribute('data-tip-open'); });
    });

    /* VirtualTailor.js fires tailorCompleteChanged in this tab; storage covers other tabs. product-sizing
       re-writes the selected option's keys on both, so this does too. */
    function onTailorChange() { write(currentOption()); render(); }
    window.addEventListener('tailorCompleteChanged', onTailorChange);
    window.addEventListener('storage', function (e) { if (e.key === 'tailor2Complete') onTailorChange(); });

    /* Parity: Virtual Tailor is picked on every page load and the keys are written right away. */
    var vt = fit.querySelector('.bl-fit__input[value="vt"]');
    if (vt) vt.checked = true;
    write('vt');
    render();
    ctx.renderFit = render;
  }

  /* ---------- Monogram ---------- */
  function initMonogram(root, ctx) {
    var box = root.querySelector('[data-bl-mono]');
    var toggle = root.querySelector('[data-bl-mono-toggle]');
    if (!box || !toggle) return;
    var fields = root.querySelector('[data-bl-mono-fields]');
    var input = root.querySelector('[data-bl-mono-input]');
    var color = root.querySelector('[data-bl-mono-color]');
    var form = toggle.form;
    var atc = root.querySelector('[data-bl-atc]');
    var error = root.querySelector('[data-bl-atc-error]');
    var addonId = Number(box.dataset.addonId);
    var busy = false;

    function setBusy(on) {
      busy = on;
      if (atc) {
        atc.classList.toggle('is-busy', on);
        if (on) atc.setAttribute('aria-busy', 'true');
        else atc.removeAttribute('aria-busy');
      }
    }
    function showError(message) {
      if (!error) return;
      error.textContent = message || '';
      error.hidden = !message;
    }
    function sync() {
      var on = toggle.checked;
      fields.hidden = !on;
      input.disabled = !on;
      color.disabled = !on;
      setBusy(false);
      showError('');
      ctx.renderAtc();
    }
    ctx.monoOn = function () { return toggle.checked; };
    toggle.disabled = false; /* rendered disabled: no script, no monogram (it could not be charged) */
    toggle.addEventListener('change', function () {
      sync();
      if (toggle.checked) input.focus();
    });
    input.addEventListener('input', function () {
      var clean = input.value.toUpperCase().replace(/[^A-Z]/g, '').slice(0, 3); /* live limit: 3 */
      if (clean !== input.value) input.value = clean;
    });

    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    function add(items) {
      return fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (res) {
        if (res.ok) return res.json();
        return res.json().catch(function () { return {}; }).then(function (body) {
          var err = new Error(body.description || ''); /* Shopify's own, shopper-facing ("... sold out") */
          err.fromCart = true;
          throw err;
        });
      });
    }

    /* Ticked: one cart call with the pant (its properties as the form would post them) and the add-on nested
       under it; the browser has already checked the initials. A store that can't nest lines (Script Editor
       installed) refuses the call, so retry once with the add-on as a plain line. Unticked: the normal post. */
    if (form) form.addEventListener('submit', function (e) {
      if (!toggle.checked || !addonId) return;
      e.preventDefault();
      if (busy) return;
      var data = new FormData(form);
      var id = Number(data.get('id'));
      var qty = Math.max(1, parseInt(data.get('quantity'), 10) || 1);
      var properties = {};
      data.forEach(function (value, key) {
        var m = /^properties\[(.+)\]$/.exec(key);
        if (m) properties[m[1]] = value;
      });
      var addon = { id: addonId, quantity: qty, parent_id: id };
      var items = [{ id: id, quantity: qty, properties: properties }, addon];
      setBusy(true);
      showError('');
      add(items)
        .catch(function () { delete addon.parent_id; return add(items); })
        .then(function () { window.location.href = base + 'cart'; })
        .catch(function (err) {
          setBusy(false);
          showError(err.fromCart && err.message ? err.message : 'We couldn’t add this to your cart. Please try again.');
        });
    });

    sync();
    return sync;
  }

  /* The section's inline script drops name="id" while the page parses so SC Product Options (legacy mode,
     scans [name="id"] on DOMContentLoaded) never mounts in this form. Put the name back once that scan is
     over, and in any case before the form is serialised: submit fires before the entry list is built, and
     Shopify's add-to-cart analytics (attached at window load) reads form.elements.id on submit. */
  function holdVariantName(root) {
    var input = root.querySelector('[data-bl-variant-id]');
    var form = input && input.form;
    if (!form) return;
    function restore() { if (!input.name) input.name = 'id'; }
    if (document.readyState === 'complete') restore();
    else window.addEventListener('load', restore);
    form.addEventListener('submit', restore);
    form.addEventListener('formdata', function (e) {
      if (!e.formData.get('id')) e.formData.set('id', input.value);
    });
  }

  /* The site nav (<nav-component>, fixed, in a shadow root) takes no room in the page, and the theme's
     content offset changes with the breakpoint. Pad the section by exactly the part of the nav covering it;
     re-measure when the nav resizes (breakpoint, announcement bar closed) or the window does. */
  function clearNav(root) {
    var host = document.querySelector('nav-component');
    var nav = host && host.shadowRoot && host.shadowRoot.querySelector('nav');
    if (!nav) return;
    function measure() {
      var navBottom = nav.getBoundingClientRect().bottom; /* fixed at top: 0 */
      var margin = parseFloat(getComputedStyle(root).marginTop) || 0; /* our own pull-up, from a previous pass */
      var overlap = Math.round(navBottom - (root.getBoundingClientRect().top + window.scrollY - margin));
      /* Covered by the nav: pad by the overlap. Below the nav (phones): pull up so no white strip shows. */
      root.style.setProperty('--bl-nav-clear', Math.max(0, overlap) + 'px');
      root.style.setProperty('--bl-nav-gap', Math.min(0, overlap) + 'px');
    }
    measure();
    if (window.ResizeObserver) new ResizeObserver(measure).observe(nav);
    var timer;
    window.addEventListener('resize', function () { clearTimeout(timer); timer = setTimeout(measure, 120); });
    window.addEventListener('load', measure);
  }

  function setup(root) {
    if (root.dataset.blReady) return;
    root.dataset.blReady = '1';
    clearNav(root);
    holdVariantName(root);

    var ctx = { panels: {}, active: null, variant: null, fitBlocked: false };
    initShared(root, ctx);
    all(root, '.bl-pdp__panel[data-bl-panel]').forEach(function (el) {
      var panel = makePanel(root, el, ctx);
      ctx.panels[panel.id] = panel;
      if (!el.hidden && !ctx.active) ctx.active = panel;
    });
    Object.keys(ctx.panels).forEach(function (id) { ctx.panels[id].refresh(false); });
    initPair(root, ctx);
    ctx.syncWomens();
    initFit(root, ctx);
    var syncMono = initMonogram(root, ctx);
    ctx.renderAtc();

    /* Back from /cart restores the page from the bfcache with the old form state; re-sync it. */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      if (ctx.active) ctx.active.refresh(false);
      ctx.syncWomens();
      if (ctx.renderFit) ctx.renderFit();
      if (syncMono) syncMono();
    });
  }

  function init(scope) { all(scope || document, '[data-bl-pdp]').forEach(setup); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  /* Theme editor re-renders sections; bind the new markup. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
